import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation } from '@tanstack/react-query'

export default function useResetPassword({
  setError = null,
  clientServerFieldMapping = null,
} = {}) {
  const action = async ({
    token,
    password,
    email,
  }: {
    token: string
    password: string
    email: string
  }) => {
    const response = await httpClient.post('auth/reset-password', {
      token,
      password,
      email,
      password_confirmation: password,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (error, variables) =>
      handleFormError({
        error,
        variables,
        setError,
        clientServerFieldMapping,
      }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
  //   return useQuery({ queryKey: ['login'], queryFn: action })
}
